import request from '@/utils/request'

/** 读取现场派工产能上限（派工编辑或全局管理员） */
export const getDispatchSiteCapacitySettings = () => {
  return request({
    url: '/api/dispatch-site-capacity/settings',
    method: 'get'
  })
}

/** 预览指定指派、交期、明细下的占用与是否超限 */
export const getDispatchSiteCapacityPreview = (params) => {
  return request({
    url: '/api/dispatch-site-capacity/preview',
    method: 'get',
    params
  })
}

/** 管理员读取/保存产能上限 */
export const getAdminDispatchSiteCapacity = () => {
  return request({
    url: '/api/admin/dispatch-site-capacity',
    method: 'get'
  })
}

export const putAdminDispatchSiteCapacity = (data) => {
  return request({
    url: '/api/admin/dispatch-site-capacity',
    method: 'put',
    data
  })
}
